import React from 'react'

/**
 * Renders dynamic form fields based on JSONB field definitions.
 * Used by IntakeFormModal, recruitment form in apply modal, and contact team modal.
 *
 * Props:
 * - fields: Array of { id, type, label, required, placeholder?, options? }
 * - responses: Object { [fieldId]: value }
 * - errors: Object { [fieldId]: boolean }
 * - onChange: (fieldId, value) => void
 */
export default function DynamicFormFields({ fields, responses, errors, onChange, translations = {} }) {
  return (
    <>
      {fields.map(field => (
        <div key={field.id} className="mb-4">
          <label className="block text-sm font-medium mb-1.5" style={{ color: '#222222' }}>
            {field.label}
            {field.required && <span className="text-red-500 ml-0.5">*</span>}
          </label>

          {field.type === 'text' && (
            <input
              type="text"
              value={responses[field.id] || ''}
              onChange={(e) => onChange(field.id, e.target.value)}
              placeholder={field.placeholder || ''}
              className={`w-full px-3 py-2.5 border rounded-lg text-sm focus:outline-none focus:ring-2 transition-colors ${
                errors[field.id]
                  ? 'border-red-400 focus:ring-red-200'
                  : 'border-gray-300 focus:ring-blue-200 focus:border-blue-400'
              }`}
            />
          )}

          {field.type === 'select' && (
            <select
              value={responses[field.id] || ''}
              onChange={(e) => onChange(field.id, e.target.value)}
              className={`w-full px-3 py-2.5 border rounded-lg text-sm focus:outline-none focus:ring-2 transition-colors ${
                errors[field.id]
                  ? 'border-red-400 focus:ring-red-200'
                  : 'border-gray-300 focus:ring-blue-200 focus:border-blue-400'
              }`}
            >
              <option value="">{translations.pleaseSelect || 'Please select'}</option>
              {field.options?.map(opt => (
                <option key={opt} value={opt}>{opt}</option>
              ))}
            </select>
          )}

          {errors[field.id] && (
            <p className="text-red-500 text-xs mt-1">{translations.fieldRequired || 'This field is required'}</p>
          )}
        </div>
      ))}
    </>
  )
}
